import { render, staticRenderFns } from "./TaskDropQuantityFields.vue?vue&type=template&id=3056fda8&"
import script from "./TaskDropQuantityFields.vue?vue&type=script&lang=js&"
export * from "./TaskDropQuantityFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports